import React, { useEffect } from 'react';
import { SecurityBoundary, PermissionBoundary } from '@vehix/portal/lib/security';
import { logDataAccess } from '@vehix/portal/lib/security/audit';
import { SystemRole } from '@vehix/portal/types';
import { useAuth } from '@vehix/shared/admin/portal-bridge';
import { ZoneSetupTab } from '@vehix/portal/features/admin/components/ZoneSetupTab';

/**
 * Zone List page — the tabular zone management view, decoupled from the
 * Zone Map page so each is a top-level Setup item in the sidebar instead
 * of being hidden behind an in-page List/Map toggle.
 */
const ZoneListPage: React.FC = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      logDataAccess({
        resource: 'zone_list',
        action: 'view',
        metadata: { page: 'setup-zone-list' }
      }).catch(() => {
        /* silent — audit logging should not surface errors */
      });
    }
  }, [user]);

  return (
    <SecurityBoundary
      requiredSystemRole={SystemRole.SUPER_ADMIN}
      auditPageAccess='setup-zone-list'
      tenantIsolation={false}
    >
      <div className='flex h-full w-full flex-col overflow-hidden'>
        <PermissionBoundary require={{ resource: 'users', action: 'manage' }}>
          <ZoneSetupTab />
        </PermissionBoundary>
      </div>
    </SecurityBoundary>
  );
};

export default ZoneListPage;
